import { Packet } from '@escrowtab/packets-api-client';
import { ProfileDto } from '@escrowtab/v2profile-api-client';
import {
  AuditAction,
  EtJournalEntry,
  EtjournalPacketEntry,
  EtJournalSigner,
} from '@et/typings';

export interface EjournalSessionModel {
  profile: ProfileDto | undefined;
  selectedPacket: Packet | null;
  eJournal: EtjournalPacketEntry | null;
  signers: EtJournalSigner[];
  entries: EtJournalEntry[];
  notarizedAuditActions: AuditAction[];
  /** True once a Notarized audit fetch has completed successfully (empty is valid). */
  notarizedAuditLoaded: boolean;
  /** Page number → document name from markup `aiPageType.category`. */
  pageNamesByNumber: Record<number, string>;
  eJournalLoading: boolean;
  signersLoading: boolean;
  entriesLoading: boolean;
  eJournalError: string | null;
  signersError: string | null;
  entriesError: string | null;
  ip: string | null;
}

export const EJOURNAL_SESSION_DEFAULTS: EjournalSessionModel = {
  profile: undefined,
  selectedPacket: null,
  eJournal: null,
  signers: [],
  entries: [],
  notarizedAuditActions: [],
  notarizedAuditLoaded: false,
  pageNamesByNumber: {},
  eJournalLoading: false,
  signersLoading: false,
  entriesLoading: false,
  eJournalError: null,
  signersError: null,
  entriesError: null,
  ip: null,
};
